import React, { createContext, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/solid";
import html2canvas from "html2canvas";
import { saveAs } from 'file-saver';

import { retrieveS3SharePath, mutateCreateNote, getSlideInfo } from "../../redux/reducers/animalResearchSlice";

import message, { MessageContainer } from "../../qg-components/src/libs/Message/index";

import SlideList from "./component/slideList";
import RotationCircle from './component/rotationCircle2';
import OpenSeaDragonViewer from "./component/viewer";
import SlideOverview from "./component/slideOverview";
import RightBar from "./component/rightBar";
import ActionNote from "./component/actionNode";
import DataCollapse from "./component/dataCollapse";
import AiBox from "./component/aibox";

import { useShowHook } from "./hooks/showDialogHook";
import { useSlides } from "./hooks/slidesHook";
import { useViewState } from "./hooks/viewerStateHook";
import { useAnnotoriou } from "./hooks/annotoriouHook";
import { useZoom } from "./hooks/zoomHook";
import { useS3 } from "./hooks/s3hook";

import viewerContext from "./utils/viewerContext";

export const viewImgContext = createContext(null);

const Viewer = (props, ref) => {
  const usedispatch = useDispatch();

  const {
    isShowSlidesLoading, isShowSlideList, isShowData, isShowAi, isShowActionNote, setIsShowSlideList, setIsShowSlideOverview,
    setIsShowSlidesLoading, isShowSlideOverview, isShowRotationCircle, setIsShowData, setIsShowAi, setIsShowRotationCircle,
    dataBoxClasss, aiClass, dataClass, setIsShowActionNote
  } = useShowHook();
  const { annoHistory, annotorious, annotations, setAnnotorious, removeAnno, updateAnnoInfo, addAnnotations, reductionAnno, setAnnoHistory } = useAnnotoriou(props);
  const { maxZoomLive, zoomLive, setZoomLive, setMaxZoomLive } = useZoom();
  const { slides, setSlides } = useSlides(props);
  const { s3State, dispatchS3State } = useS3(props);
  const { viewerState, dispatchViewerState, image, metadata, studyInfo, afterChangeSlideId, setStudyInfo } = useViewState({ ...props, setSlides, reductionAnno, setAnnoHistory, setIsShowSlidesLoading, dispatchS3State });
  // RotationCircle圆圈中的数字
  const [rotationDegree, setRotationDegree] = useState(0);
  // 从actionNode里面把这个state提上来
  const [editNote, setEditNote] = useState(null);
  // 当前操作的nodte
  const [actionNoteType, setActionNoteType] = useState("");

  const handleAddAnnotations = (anno) => {
    addAnnotations(anno, viewerState, studyInfo)
  };

  const seleChange = (item) => {
    setAnnoHistory([]);
    dispatchViewerState({
      type: "changeSlideId",
      value: { id: item.ID }
    })
  };

  /**
   * 点击ScreenShot截图按钮的行为
   */
  const handleScreenShot = () => {
    // 获取viewer进行截图
    if (!window.viewer) {
      console.error("No viewer found.")
      return
    }
    // // 这里应该OpenSeadragon已经有screenshot的功能了
    // OpenSeadragon.ScreenShot.takeScreenshot()

    // AWS-262 使用跟Cronus一致的html2canvas的包来截图
    const notWorking1 = () => {
      const openseadragonCanvas = document.querySelector("div.openseadragon-canvas canvas")
      html2canvas(
        document.querySelector("body"),
        {
          // 不知道这些哪个起作用了，反正CORS的问题看起来解决了，至少能够产生文件。
          allowTaint: true,
          foreignObjectRendering: true,
          useCORS: true,
        }
      ).then(
        (canvas) => {
          canvas.toBlob((blob) => {
            saveAs(blob, "abc.png")
          })
        }
      )

      // 这种代码的问题是，产生的图是没有东西的
    }

    const notWorking2 = () => {
      const capture = async () => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        const video = document.createElement("video");

        try {
          const captureStream = await navigator.mediaDevices.getDisplayMedia();
          video.srcObject = captureStream;
          context.drawImage(video, 0, 0, window.width, window.height);
          const frame = canvas.toDataURL("image/png");
          captureStream.getTracks().forEach(track => track.stop());
          window.location.href = frame;
        } catch (err) {
          console.error("Error: " + err);
        }
      };

      capture();
    }

    notWorking1()
  };

  /**
   * 开始画 支持圆 线 自由勾画 矩形 多边形（point line freehand polygon ellipse）
   * @param { String } tool 
   */
  const handleClickDraw = (tool) => {
    annotorious.setDrawingEnabled(true);
    annotorious.setDrawingTool(tool);
  };

  const onSubmit = () => {
    seleChange(studyInfo);
  };

  const openNoteDialog = (type) => {
    setIsShowActionNote(1);
    setActionNoteType(type);
  };

  const handleClickAnno = (id) => {
    annotorious.selectAnnotation(id);
    annotorious.setDrawingEnabled(false);
  };

  // 确认并复制到slideNote
  const confirmCopySlideNote = (item) => {
    let { ID, type, __typename, ...items } = JSON.parse(item);
    let params = { ...items, NoteType: "SlideNote" };
    usedispatch(mutateCreateNote(params, (info) => {
      usedispatch(getSlideInfo({ id: info.SlideID }, (info) => {
        setStudyInfo(info);
        message.success("添加成功");
      }));
    }))
  };

  return (
    <div className="h-full w-full flex flex-col">
      <nav className="w-full flex-1 flex min-h-0">
        <viewImgContext.Provider value={{
          annoHistory,
          annotorious,
          isShowActionNote,
          isShowSlidesLoading,
          slides,
          zoomLive,
          studyInfo,
          actionNoteType,
          annotations,
          editNote,
          setEditNote,
          handleClickDraw,
          setZoomLive,
          handleScreenShot,
          onSubmit,
          setMaxZoomLive,
          confirmCopySlideNote,
          handleClickAnno: handleClickAnno,
          showActionNoteBox1: () => {setIsShowActionNote(0)},
          showActionNoteBox: openNoteDialog,
          showRightDialog: () => { setIsShowData(!isShowData) },
          showAiDialog: () => { setIsShowAi(!isShowAi) },
          handleRotationCircle: () => { setIsShowRotationCircle(x => !x) },
          handleSlideOverview: () => { setIsShowSlideOverview(x => !x) },
          seleChange,
          ...viewerState
        }}>
          {/* slide list */}
          <div className={`h-full w-40 max-h-full p-2 relative ${isShowSlideList ? 'show-slide' : 'hide-slide'}`} style={{ "boxShadow": "0 8px 12px #ebedf0" }}>
            <SlideList></SlideList>
            {/* 收起展开的小圆球icon */}
            <div className={`w-8 h-8 border rounded-full bg-gray-100 flex items-center justify-center absolute top-14 -right-4 z-10`} onClick={() => { setIsShowSlideList(!isShowSlideList) }}>
              {isShowSlideList && <ChevronLeftIcon className="w-5 bounce-icon-left cursor-pointer"></ChevronLeftIcon>}
              {!isShowSlideList && <ChevronRightIcon className="w-5 bounce-icon-left cursor-pointer"></ChevronRightIcon>}
            </div>
          </div>

          {/* viewer */}
          <div className="relative h-full flex-1 flex-shrink-0">
            <viewerContext.Provider value={{
              maxZoomLive,
              rotationDegree,
              annoHistory,
              image,
              annotorious,
              setZoomLive,
              setRotationDegree,
              updateAnnoInfo,
              removeAnno,
              setMaxZoomLive,
              setAnnotorious,
              handleAddAnnotations: handleAddAnnotations,
              // showActionNoteBox: () => { setIsShowActionNote(0) },
              ...props
            }}>
              {image && <OpenSeaDragonViewer></OpenSeaDragonViewer>}
              {/* rotationCircle 旋转用的圆圈 */}
              {isShowRotationCircle && <div className="absolute bottom-16 left-8">
                <RotationCircle />
              </div>}
              {
                isShowSlideOverview && s3State?.slide_overview && <div className="absolute top-8 left-8">
                  <SlideOverview url={s3State.slide_overview} />
                </div>
              }
            </viewerContext.Provider>
          </div>

          {/* data */}
          <div id="databox" className={`h-full bg-white flex-shrink-0 relative ${dataBoxClasss}`} style={{ "boxShadow": "0 8px 12px #ebedf0" }}>
            {/* action Note */}
            <ActionNote></ActionNote>
            <DataCollapse className={dataClass}></DataCollapse>
            <AiBox className={aiClass}></AiBox>
          </div>

          {/* 倍数 工具栏 */}
          <div className="h-full w-14 flex-shrink-0 bg-gray-100 z-20" id="bar">
            <RightBar></RightBar>
          </div>
        </viewImgContext.Provider>
      </nav>
    </div>
  )
};

export default Viewer;